import { formatJsonDataset as fjd } from "../../components/renderers";

export const kpisconfig = {

  objective: {
    service: {
      name: 'objective',
      title: 'Objectives',
      num: true,
      fields: ['rid','nam','shc','dsc','ati','atn','atc','opi','opn','opc','cci','ccn','ccc','osi','osn','osc','axi','axn','axc','edi','edn','edc','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['atn','Type'],
        ['opn','Parent'],
        ['ccn','Cost Center'],
        ['osn','State'],
        ['axn','Axis'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Axis', v:'axn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'ati', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivetype' } },
        { id:'opi', label:'Parent Objective', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'objective' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'osi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivestate' } },
        { id:'axi', label:'Axis', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'axis' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },
  
  kpimaster: {
    service: {
      name: 'kpimaster',
      title: 'KPI Master',
      num: true,
      fields: ['rid','nam','shc','kti','ktn','ktc','kfi','kfn','kfc','umi','umn','umc','obi','obn','obc','fml','ipt','ksi','ksn','ksc','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['ktn','Type'],
        ['kfn','Frequency'],
        ['umn','UOM'],
        ['obn','Objective'],
        ['ksn','State'],
        ['fml','Formula'],
        ['ipt','Interpretation'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Objective', v:'obn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'kti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpitype' } },
        { id:'kfi', label:'Frequency', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpifrequency' } },
        { id:'umi', label:'UOM', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'uom' } },
        { id:'obi', label:'Objective', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objective' } },
        { id:'fml', label:'Formula', type:'ta', req:0, ops:{} },
        { id:'ipt', label:'Interpretation', type:'ta', req:0, ops:{} },
        { id:'ksi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpistate' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiplan: {
    service: {
      name: 'kpiplan',
      title: 'KPI Plans',
      num: true,
      fields: ['rid','kpi','kpn','kpc','bpi','bpn','bpc','bci','bcn','bcc','cci','ccn','ccc','blv','tgv','tmn','tmx','pti','ptn','ptc','psi','psn','psc','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpn','KPI'],
        ['bpn','Period'],
        ['bcn','Cycle'],
        ['ccn','Cost Center'],
        ['blv','Baseline'],
        ['tgv','Target'],
        ['tmn','Min Threshold'],
        ['tmx','Max Threshold'],
        ['ptn','Type'],
        ['psn','State'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI', v:'kpn' },
          { t:'Period', v:'bpn' },
          { t:'Cost Center', v:'ccn' }
        ],
        def:'kpn'
      },
      eform: [
        { id:'kpi', label:'KPI', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpimaster' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'bci', label:'Cycle', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetcycle' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'blv', label:'Baseline Value', type:'nf', req:0, ops:{} },
        { id:'tgv', label:'Target Value', type:'nf', req:0, ops:{} },
        { id:'tmn', label:'Threshold Min', type:'nf', req:0, ops:{} },
        { id:'tmx', label:'Threshold Max', type:'nf', req:0, ops:{} },
        { id:'pti', label:'Plan Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplantype' } },
        { id:'psi', label:'Plan State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplanstate' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiactivitylink: {
    service: {
      name: 'kpiactivitylink',
      title: 'KPI Activity Links',
      num: true,
      fields: ['rid','kpi','kpn','kpc','aci','acn','acc','cwt','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpn','KPI'],
        ['acn','Activity'],
        ['cwt','Contribution Weight'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI', v:'kpn' },
          { t:'Activity', v:'acn' }
        ],
        def:'kpn'
      },
      eform: [
        { id:'kpi', label:'KPI', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpimaster' } },
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'cwt', label:'Contribution Weight', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpioutputlink: {
    service: {
      name: 'kpioutputlink',
      title: 'KPI Output Links',
      num: true,
      fields: ['rid','kpi','kpn','kpc','opi','opn','opc','cwt','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpn','KPI'],
        ['opn','Output'],
        ['cwt','Contribution Weight'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI', v:'kpn' },
          { t:'Output', v:'opn' }
        ],
        def:'kpn'
      },
      eform: [
        { id:'kpi', label:'KPI', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpimaster' } },
        { id:'opi', label:'Output', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activityoutput' } },
        { id:'cwt', label:'Contribution Weight', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiplanactivitylink: {
    service: {
      name: 'kpiplanactivitylink',
      title: 'KPI Plan Activity Links',
      num: true,
      fields: ['rid','pni','kpc','api','acn','acc','cwt','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpc','KPI Plan'],
        ['acn','Activity Plan'],
        ['cwt','Contribution Weight'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI Plan', v:'kpc' },
          { t:'Activity Plan', v:'acn' }
        ],
        def:'kpc'
      },
      eform: [
        { id:'pni', label:'KPI Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplan' } },
        { id:'api', label:'Activity Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activityplan' } },
        { id:'cwt', label:'Contribution Weight', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiperformance: {
    service: {
      name: 'kpiperformance',
      title: 'KPI Performance',
      num: true,
      fields: ['rid','pni','kpc','pdt','acv','vav','com','evi','psi','psn','psc','edi','edn','edc','exi','sts','ast','stp'],
      grid: [
        ['kpc','KPI Plan'],
        ['pdt','Performance Date'],
        ['acv','Actual Value'],
        ['vav','Variance'],
        ['com','Commentary'],
        ['evi','Evidence'],
        ['psn','State'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI Plan', v:'kpc' },
          { t:'Date', v:'pdt' }
        ],
        def:'kpc'
      },
      eform: [
        { id:'pni', label:'KPI Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplan' } },
        { id:'pdt', label:'Performance Date', type:'df', req:1, ops:{} },
        { id:'acv', label:'Actual Value', type:'nf', req:1, ops:{} },
        { id:'vav', label:'Variance Value', type:'nf', req:0, ops:{} },
        { id:'com', label:'Commentary', type:'ta', req:0, ops:{} },
        { id:'evi', label:'Evidence Info', type:'jf', req:0, ops:{} },
        { id:'psi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiperformancestate' } },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd, evi:fjd } }
  },

};